export { default } from "./Card4x6"
